import React, { useEffect, useContext } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Container, Row, Col, Button } from "react-bootstrap";
import BuildSentence from "./BuildSentence";
import InsertSpaces from "./InsertSpaces";
import ReadArticle from "./ReadArticle";
// import Wordonstructor from "./WordConstructor";
import { setActiveExercise } from "../../../redux/slices/exerciseSlice";
import { fetchUserVocabulary } from "../../../redux/slices/userVocabularySlice";
import { UserContext } from "../../user/UserContext";

import "./ReadingExercises.css";

export default function ExercisesTab(props) {
  const dispatch = useDispatch(); // Initialize the Redux dispatch function
  const { userAttributes } = useContext(UserContext);

  const activeExercise = useSelector((state) => state.exercise.activeExercise); // Access the active exercise from the Redux store
  const userWords = useSelector((state) => state.userVocabulary.userWords); // Access the user vocabulary from the Redux store

  // Effect to check if the user has no words
  useEffect(() => {
    const fetchAndCheckWords = async () => {
      if (userWords.length === 0) {
        try {
          // Fetch user vocabulary
          await dispatch(fetchUserVocabulary({ owner: userAttributes.sub }));
        } catch (error) {
          console.error("Error fetching user vocabulary:", error);
        }
      }
    };

    fetchAndCheckWords();
  }, [userWords, dispatch, userAttributes.sub]);

  let exercise;

  switch (activeExercise) {
    case "Build a sentence":
      exercise = <BuildSentence />;
      break;

    case "Insert Spaces":
      exercise = <InsertSpaces />;
      break;

    case "Read an Article":
      exercise = <ReadArticle />;
      break;

    // case "word-constructor":
    //   exercise = <Wordonstructor />;
    //   break;

    default:
      exercise = null;
      break;
  }

  // If an exercise is active, render it
  if (exercise) {
    return exercise;
  }

  return (
    <div className="d-flex flex-nowrap pt-2">
      <Container>
        <Row>
          <Col md={1}></Col>
          <Col md={10}>
            <h1 className="text-center">Select an Exercise</h1>{" "}
            {/* Page title */}
          </Col>
          <Col md={1}></Col>
        </Row>
        <Row className="g-3" style={{ minHeight: "300px" }}>
          {/* Button to select "Build a sentence" exercise */}
          <Col
            xs={6}
            sm={6}
            md={4}
            lg={3}
            className="d-flex align-items-center justify-content-center"
          >
            <Button
              variant="primary"
              size="lg"
              className="w-100 exercise-btn"
              style={{ height: "auto", aspectRatio: "1/1" }} // Maintain square aspect ratio
              onClick={() => dispatch(setActiveExercise("Build a sentence"))} // Set active exercise to "Build a sentence"
            >
              Build a sentence
            </Button>
          </Col>
          {/* Button to select "Insert Spaces" exercise */}
          <Col
            xs={6}
            sm={6}
            md={4}
            lg={3}
            className="d-flex align-items-center justify-content-center"
          >
            <Button
              variant="primary"
              size="lg"
              className="w-100 exercise-btn"
              style={{ height: "auto", aspectRatio: "1/1" }} // Maintain square aspect ratio
              onClick={() => dispatch(setActiveExercise("Insert Spaces"))}
            >
              Insert Spaces
            </Button>
          </Col>
          {/* Button to select "Read an Article" exercise */}
          <Col
            xs={6}
            sm={6}
            md={4}
            lg={3}
            className="d-flex align-items-center justify-content-center"
          >
            <Button
              variant="primary"
              size="lg"
              className="w-100 exercise-btn"
              style={{ height: "auto", aspectRatio: "1/1" }} // Maintain square aspect ratio
              onClick={() => dispatch(setActiveExercise("Read an Article"))}
            >
              Read an Article
            </Button>
          </Col>
          {/* Placeholder button for Exercise #4 */}
          <Col
            xs={6}
            sm={6}
            md={4}
            lg={3}
            className="d-flex align-items-center justify-content-center"
          >
            {/* <Button
              variant="primary"
              size="lg"
              className="w-100 exercise-btn"
              style={{ height: "auto", aspectRatio: "1/1" }} // Maintain square aspect ratio
              onClick={() => dispatch(setActiveExercise("word-constructor"))}
            >
              Word Constructor
            </Button> */}
          </Col>
        </Row>
      </Container>
    </div>
  );
}
